import { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { SYS_API_URL } from '../comm/config';
import { i18n } from '../language';

const authApiEndPoint = `${SYS_API_URL}/loginHccByApiGateway`;

export const useCommandCentre = () => {
  const [src, setSrc] = useState('');
  const loginInfo = useSelector((state) => state.loginInfo);
  const getBridgeUrl = async () => {
    try {
      const result = await axios.get(`/wp_command_center_sso_sdk`);
      setSrc(result.data);
      console.log('result', result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBridgeUrl();
  }, []);

  const handleCommandCentre = useCallback(
    (wardInfo) => {
      const loadShccBridge = () => {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          document.body.appendChild(script);
          script.onload = (event) => {
            if (window['shccBridge']) {
              resolve(window['shccBridge']);
            } else {
              reject(false);
            }
          };
        });
      };

      const wardPlaceAPI = `${authApiEndPoint}`;
      const corpId = loginInfo.corpID;
      const hospital = wardInfo.hospCode;
      const wardLocation = wardInfo.wardLocation;
      console.log(wardPlaceAPI);
      console.log(corpId);
      console.log(hospital);
      console.log(wardLocation);

      loadShccBridge()
        .then((shccBridge) => {
          console.log('shccBridge', shccBridge);
          shccBridge
            .openWardDashboard({
              loginShccApi: wardPlaceAPI,
              userId: corpId,
              hospital: hospital,
              wardLocation: wardLocation,
              loginType: 'API',
            })
            ?.catch((error) => {
              console.error(error);
              handleError(error);
            });
        })
        .catch((error) => {
          console.error(error);
          handleError(error);
        });
    },
    [loginInfo, src]
  );

  return handleCommandCentre;
};

const handleError = (error) => {
  if (
    error.message?.toUpperCase()?.includes('Login'.toUpperCase()) ||
    error.message?.toUpperCase()?.includes('permission'.toUpperCase())
  ) {
    alertMsg(i18n.t('BEDSTATUS_COMMAND_CENTRE_ERROR_PERMISSION'));
  } else {
    alertMsg(i18n.t('BEDSTATUS_COMMAND_CENTRE_ERROR_SERVER_BUSY'));
  }
};

const alertMsg = (msg, ID, type = 'error', timeout = null) => {
  const alertEl = document.createElement('div');
  alertEl.setAttribute('id', ID);
  document.getElementById('root').appendChild(alertEl);
  ReactDOM.render(
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={() => {
        closeAlert(ID);
      }}
      autoHideDuration={timeout}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={() => {
          closeAlert(ID);
        }}
        severity={type}
      >
        <div dangerouslySetInnerHTML={{ __html: msg }} />
      </MuiAlert>
    </Snackbar>,
    alertEl
  );
};

const closeAlert = (ID) => {
  const targetEl = document.getElementById(ID);
  targetEl?.remove();
};
